import React from "react";
import { Link } from "react-router-dom";

const TOOLS = [
    {
        title: "Определить рыбу по фото",
        description: "Загрузите фотографию рыбы и получите результат распознавания вида с помощью нейросети.",
        to: "/tools/fish-detection",
    },
    {
        title: "Загрузка точек эхолота",
        description: "Загрузите CSV с точками глубин на карту. Пустые координаты будут пропущены автоматически.",
        to: "/tools/sonar-upload",
    },
];

export default function ToolsPage() {
    return (
        <div className="blog-page-root">
            <div className="blog-page-inner tools-page-inner">
                <div className="blog-page-header">
                    <div className="blog-head">
                        <h2 className="blog-page-title">Инструменты</h2>
                    </div>
                </div>

                <div className="tools-page-grid">
                    {TOOLS.map((tool) => (
                        <article className="tool-glass-card" key={tool.to}>
                            <div className="tool-glass-card__body">
                                <h3 className="tool-glass-card__title">{tool.title}</h3>
                                <p className="tool-glass-card__desc">{tool.description}</p>
                            </div>
                            <div className="tool-glass-card__footer">
                                <Link to={tool.to} className="btn-outline tool-glass-card__link">
                                    Открыть инструмент
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </div>
    );
}
